import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import useFetch from '@hooks/useFetch';

const useTestAccess = (
  quizUID,
  action,
  resource,
  isSubscribedUser,
  isSpecial
) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const {
    data: uamData,
    mutate: refetchUam,
    isValidating: isUamValidating
  } = useFetch(
    isLoggedIn && !isSubscribedUser && !isSpecial
      ? `v1/user/check_access/?actions=${action}&resource=${resource}:${quizUID}`
      : null,
    {
      revalidateOnMount: true
    }
  );
  const { actionAllowed } = uamData ?? {};
  const isTestAccessPresent = actionAllowed?.[action.toLocaleLowerCase()];

  return { isTestAccessPresent, refetchUam, isUamValidating };
};

export default useTestAccess;
